import { useState } from "react";
import { NewInput, NewSelect } from "../../BaseComponents";
import { NewFieldStyles, NewFieldTypes, SelectFieldOption_Values } from "../../../Definitions";
import { colors, css, fonts, glyphs, useMediaQuery } from "../../../Styles";
import FeedCorrectionPopover from "./feedCorrectionPopover";

/* eslint-disable */
export enum FieldMode {
  select="select",
  input="input",
  feedCorrection="feedCorrection",
}
/* eslint-enable */

type BaseProps = {
  editMode?: boolean
  header: string;
  icon: keyof typeof glyphs;
  value: string | number | undefined | JSX.Element;
  undefinedValue?: string | number;
  isDisabled?: boolean;
  isClearable?: boolean;
  gridTemplateColumns?: string;
  focusView?: boolean
};

  type FeedCorrectionProps = BaseProps & {
    fieldMode: FieldMode.feedCorrection;
    onChange?: (value: number) => void
    defaultValue?: number;
  }
  
  type SelectInputProps = BaseProps & {
    fieldMode: FieldMode.select;
    options: SelectFieldOption_Values[];
    onchange?: (e: SelectFieldOption_Values | undefined) => void;
    // onClear?: () => void;
    defaultValue?: SelectFieldOption_Values | undefined;
  };
  
  type TextInputProps = BaseProps & {
    fieldMode: FieldMode.input;
    onchange?: (e: string) => void;
    onBlur?: () => void;
    // onClear?: () => void;
    defaultValue?: string | number;
    type?: string
  };
  
  type InfoDisplayInputProps = SelectInputProps | TextInputProps | FeedCorrectionProps;

  export default function LineInfoDisplay(props: InfoDisplayInputProps) {
    const { header, icon, value, undefinedValue, editMode, isDisabled, isClearable, gridTemplateColumns, focusView} = props;
    const IconComponent = glyphs[icon];
    const mobileXs = useMediaQuery(`(max-width: 450px)`);
    
    const _fieldStyle = NewFieldStyles.greySecondary;
    const _fieldWidth = "100%"
    const _gridTemplateColumns = gridTemplateColumns ? gridTemplateColumns : "2fr 25px 3fr"
    if (props.fieldMode === FieldMode.input) {
    }
    return (
      <div style={{...css.basic_Info_style, ...fonts.fontSize3, width: "100%", maxWidth: "320px", gridTemplateColumns: _gridTemplateColumns}}>
        <div style={{gridArea: "1/1/2/2", ...css.basicInfo_rightStyle, marginRight: "10px", height: focusView ? "40px" : "25px"}}>{header}</div>
        <div style={{gridArea: "1/2/2/3", ...css.basicInfo_centerStyle, height: focusView ? "40px" : "25px"}}>{IconComponent && <IconComponent size="25px" />}</div>
        <div style={{gridArea: "1/3/2/4", ...css.basicInfo_leftStyle, marginLeft: editMode ? "5px" : "10px", height: focusView ? "40px" : "25px"}}>
        { editMode? 
          props.fieldMode === FieldMode.select ? 
            <NewSelect
              // onClear={props.onClear}n
              onChange={props.onchange}
              options={props.options ?? []}
              isDisabled={isDisabled}
              isClearable={isClearable}
              fieldOverrides={{
                fieldStyle: _fieldStyle,
                fieldWidth: _fieldWidth,
                focus_view: focusView
              }}
              valueOverrides={{
                defaultValue: props.defaultValue
              }}
            />
          : props.fieldMode === FieldMode.input ?
            <NewInput
              onChange={props.onchange}
              onBlur={props?.onBlur}
              // onClear={props.onClear}
              isDisabled={isDisabled}
              isClearable={isClearable}
              fieldOverrides={{
                fieldStyle: _fieldStyle,
                fieldWidth: _fieldWidth,
                focus_view: focusView
              }}
              valueOverrides={{
                defaultValue: props.defaultValue,
                valueType: props.type,
                minValueNumber: 0
              }}
            />
          : props.fieldMode === FieldMode.feedCorrection ?
            <FeedCorrectionPopover 
              focusView={props.focusView}
              onChange={props.onChange} 
              defaultValue={props.defaultValue}
              fieldOverrides={{
                fieldStyle: _fieldStyle,
                fieldHeight: focusView ? "40px" : undefined,
                fieldType: NewFieldTypes.primaryField,
                fieldWidth: "100%"
              }}
            />
            : <></>
          : value === undefined ? <p style={{opacity: "0.5", fontStyle: "italic"}}>{undefinedValue}</p> : <p>{value}</p>}
        </div>
      </div>
    )
  }